import { Menu } from 'antd';
import { Dispatch, SetStateAction } from 'react';
import edit from '../../../../assets/editAdminIcon.svg';
import DeactivateIcon from '../../../../components/Icons/DeactivateIcon';
import Delete from '../../../../components/Icons/Delete';
import done from '../../../../assets/Done, Check.svg';
import PreviewIcon from '../../../../components/Icons/PreviewIcon';
import copyImage from '../../../../assets/copyImage.svg';

export const getMenu = (
    id: number,
    status: string,
    setArea: Dispatch<SetStateAction<{ id: number | null; type: string }>>,
    editFunc?: any,
    type?: string,
    copyFunc?: (id: number) => void,
    previewFunc?: (id: number, formType?: string) => void
) => {
    return (
        <Menu
            style={{ border: '1px solid #001965', borderRadius: '20px' }}
            items={
                status === 'draft'
                    ? [
                          {
                              key: 'edit',
                              label: (
                                  <div className="area_action">
                                      <img src={edit} />
                                      Edit Expense Area
                                  </div>
                              ),
                              onClick: () => editFunc && editFunc(id)
                          },
                          {
                              key: 'delete',
                              label: (
                                  <div
                                      className="area_action delete"
                                      onClick={(e) => {
                                          e.stopPropagation();
                                          setArea({ id: +id, type: 'delete' });
                                      }}
                                  >
                                      <Delete /> Delete Expense Area
                                  </div>
                              )
                          },
                          {
                              key: 'copy',
                              label: (
                                  <div
                                      className="area_action"
                                      onClick={(e) => {
                                          e.stopPropagation();
                                          copyFunc && copyFunc(id);
                                      }}
                                  >
                                      <img src={copyImage} /> Copy Expense Area
                                  </div>
                              )
                          }
                      ]
                    : status === 'active'
                    ? [
                          {
                              key: 'edit',
                              label: (
                                  <div className="area_action">
                                      <img src={edit} />
                                      Edit Expense Area
                                  </div>
                              ),
                              onClick: () => editFunc && editFunc(id)
                          },
                          {
                              key: 'delete',
                              label: (
                                  <div
                                      className="area_action delete"
                                      onClick={(e) => {
                                          e.stopPropagation();
                                          setArea({ id: +id, type: 'deactivate' });
                                      }}
                                  >
                                      <DeactivateIcon /> Deactivate Expense Area
                                  </div>
                              )
                          },
                          {
                              key: 'copy',
                              label: (
                                  <div
                                      className="area_action"
                                      onClick={(e) => {
                                          e.stopPropagation();
                                          copyFunc && copyFunc(id);
                                      }}
                                  >
                                      <img src={copyImage} /> Copy Expense Area
                                  </div>
                              )
                          }
                      ]
                    : status === 'inactive'
                    ? [
                          {
                              key: 'edit',
                              label: (
                                  <div className="area_action">
                                      <img src={edit} />
                                      Edit Expense Area
                                  </div>
                              ),
                              onClick: () => editFunc && editFunc(id)
                          },
                          {
                              key: 'activate',
                              label: (
                                  <div
                                      className="area_action activate"
                                      onClick={(e) => {
                                          e.stopPropagation();
                                          setArea({ id: +id, type: 'activate' });
                                      }}
                                  >
                                      <img src={done} /> Activate Expense Area
                                  </div>
                              )
                          },
                          {
                              key: 'delete',
                              label: (
                                  <div
                                      className="area_action delete"
                                      onClick={(e) => {
                                          e.stopPropagation();
                                          setArea({ id: +id, type: 'delete' });
                                      }}
                                  >
                                      <Delete /> Delete Expense Area
                                  </div>
                              )
                          },
                          {
                              key: 'copy',
                              label: (
                                  <div
                                      className="area_action"
                                      onClick={(e) => {
                                          e.stopPropagation();
                                          copyFunc && copyFunc(id);
                                      }}
                                  >
                                      <img src={copyImage} /> Copy Expense Area
                                  </div>
                              )
                          }
                      ]
                    : status === 'form'
                    ? [
                          {
                              key: 'preview',
                              label: (
                                  <div className="area_action">
                                      <PreviewIcon /> Preview
                                  </div>
                              ),
                              onClick: () => previewFunc?.(id, type)
                          },
                          {
                              key: 'edit',
                              label: (
                                  <div
                                      className="area_action"
                                      onClick={(e) => {
                                          window.open(`/${type}-builder/${id}`, '_blank');
                                      }}
                                  >
                                      <img src={edit} />
                                      Edit
                                  </div>
                              )
                          }
                      ]
                    : []
            }
        />
    );
};
